import { CircularProgress } from '@mui/material';

interface FormLoadStateProps {
  isLoading: boolean;
}

const FormLoadState = ({ isLoading }: FormLoadStateProps) =>
  isLoading ? (
    <div className='w-full p-5 bg-white rounded-lg shadow-md flex justify-center'>
      <CircularProgress size={28} />
    </div>
  ) : (
    <p className='w-full p-5 bg-white rounded-lg shadow-md text-sm text-red-600'>
      No se pudieron cargar los datos del comercio para la solicitud.
    </p>
  );

export default FormLoadState;
